// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getEcommerceOrderRequest: ['filter'],
  getEcommerceOrderSuccess: ['data'],
  getEcommerceOrderFailure: ['err'],

  getEcommerceOrderShippingRequest: ['data'],
  getEcommerceOrderShippingSuccess: ['data'],
  getEcommerceOrderShippingFailure: ['err'],

  postEcommerceOrderShippingRequest: ['data'],
  postEcommerceOrderShippingSuccess: ['data'],
  postEcommerceOrderShippingFailure: ['err'],

  putEcommerceOrderShippingRequest: ['data'],
  putEcommerceOrderShippingSuccess: ['data'],
  putEcommerceOrderShippingFailure: ['err'],

  deleteEcommerceOrderShippingRequest: ['data'],
  deleteEcommerceOrderShippingSuccess: ['data'],
  deleteEcommerceOrderShippingFailure: ['err']
})

export const EcommerceOrderTypes = Types
export default Creators

/* ------------- Initial State ------------- */
export const INITIAL_STATE = Immutable({
  fetching: false,
  data: null,
  DATA_DETAIL: {},
  err: null,
  processing: false,
  success: null
})

/* ------------- Reducers ------------- */
// we're attempting to login
export const request = (state: Object) =>
  state.merge({ fetching: true, err: null })

// we've successfully logged in
export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null
  })

export const successShipping = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    DATA_DETAIL: data,
    err: null
  })

  // we've had a problem logging in
export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null })
export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    processing: false,
    success: true,
    err: null
  })
export const manipulateFailure = (state: Object, { err }: Object) =>
state.merge({ processing: false, err, success: null })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_ECOMMERCE_ORDER_SUCCESS]: success,
  [Types.GET_ECOMMERCE_ORDER_REQUEST]: request,
  [Types.GET_ECOMMERCE_ORDER_FAILURE]: failure,

  [Types.GET_ECOMMERCE_ORDER_SHIPPING_SUCCESS]: successShipping,
  [Types.GET_ECOMMERCE_ORDER_SHIPPING_REQUEST]: request,
  [Types.GET_ECOMMERCE_ORDER_SHIPPING_FAILURE]: failure,

  [Types.POST_ECOMMERCE_ORDER_SHIPPING_SUCCESS]: manipulateSuccess,
  [Types.POST_ECOMMERCE_ORDER_SHIPPING_REQUEST]: manipulateRequest,
  [Types.POST_ECOMMERCE_ORDER_SHIPPING_FAILURE]: manipulateFailure,

  [Types.PUT_ECOMMERCE_ORDER_SHIPPING_SUCCESS]: manipulateSuccess,
  [Types.PUT_ECOMMERCE_ORDER_SHIPPING_REQUEST]: manipulateRequest,
  [Types.PUT_ECOMMERCE_ORDER_SHIPPING_FAILURE]: manipulateFailure,

  [Types.DELETE_ECOMMERCE_ORDER_SHIPPING_SUCCESS]: manipulateSuccess,
  [Types.DELETE_ECOMMERCE_ORDER_SHIPPING_REQUEST]: manipulateRequest,
  [Types.DELETE_ECOMMERCE_ORDER_SHIPPING_FAILURE]: manipulateFailure
})



// WEBPACK FOOTER //
// ./src/Redux/EcommerceOrderRedux.js